import { RootState } from '@/store';

import { GetterTree } from 'vuex';
import { State } from './state';

import { Status } from '@/models/CommonModels';

export type Getters = {
  status(state: State): Status;

  publicPages(state: State): Array<string>;
  benutzerPages(state: State): Array<string>;
  adminPages(state: State): Array<string>;

  qrCodeTrennzeichen(state: State): string;
};

export const getters: GetterTree<State, RootState> & Getters = {
  status(state: State) {
    return state.status;
  },

  publicPages(state: State) {
    return state.publicPages;
  },

  benutzerPages(state: State) {
    const pages = new Array<string>();
    pages.push(...state.publicPages);
    pages.push(...state.benutzerPages);

    return pages;
  },

  adminPages(state: State) {
    const pages = new Array<string>();
    pages.push(...state.publicPages);
    pages.push(...state.benutzerPages);
    pages.push(...state.adminPages);

    return pages;
  },

  qrCodeTrennzeichen(state: State) {
    return state.qrCodeTrennzeichen;
  },
};
